import styled from 'styled-components';
import { COLORS, FONT_FAMILY, FONTS } from 'utils/styles';
import { Images } from 'assets/images';
import TextField from '@mui/material/TextField';

export const DashboardWrapper = styled.div`
  width: 100%;
  min-height: 100vh;
  padding: 20px;
  background: ${COLORS.whiteLite};
  overflow: hidden;
`;

export const MainDashboard = styled.div`
  width: 100%;
  height: 100%;
  padding: 34px;
  background: ${COLORS.white};
`;

export const ModalContainer = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  position: fixed;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  background-color: ${COLORS.multiSilver};
  overflow-y: hidden;
  z-index: 1000;
`;

export const ComponentTopBlock = styled.div`
  width: 100%;
  height: 110px;
`;

export const TitleAndAddButton = styled.div`
  display: flex;
  justify-content: space-between;
  width: 100%;
  height: 50px;
`;

export const SystemUsersAndCustomersSection = styled.div`
  display: flex;
  gap: 24px;
  width: 100%;
  height: 47px;
  border-bottom: 1px solid ${COLORS.mainColor};
`;

export const SystemUsersAndCustomersButton = styled.button`
  width: 176px;
  height: 46px;
  background: ${({ activeTab }) =>
    activeTab ? COLORS.mainColor : COLORS.whiteLite};
  color: ${({ activeTab }) => (activeTab ? COLORS.whiteLite : COLORS.black)};
  ${FONTS.font18};
  ${FONT_FAMILY.FontRegular};
  border-radius: 8px 8px 0 0;
`;

export const TitleOfPage = styled.span`
  ${FONTS.font24};
  ${FONT_FAMILY.FontMedium};
  text-transform: capitalize;
  color: ${COLORS.black};
`;

export const AddButton = styled.button`
  width: 172px;
  height: 46px;
  background: ${COLORS.mainColor};
  color: ${COLORS.white};
  ${FONT_FAMILY.FontRegular};
  ${FONTS.font18};
  text-transform: capitalize;
  border-radius: 8px;
`;

export const AboutContentBlock = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  width: 100%;
  height: 50px;
`;

export const ShowQuantityWrapper = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  width: 200px;
  height: 100%;
`;

export const SelectOptionWrapper = styled.div`
  position: relative;
  width: 228px;
  height: 32px;
  cursor: pointer;

  &::after {
    content: '';
    position: absolute;
    top: 14px;
    width: 10px;
    right: 10px;
    height: 6px;
    background: url(${Images.selectDownArrow});
    pointer-events: none;
  }
`;

export const Select = styled.select`
  width: ${({ showContentNumbers }) => (showContentNumbers ? '100%' : '228px')};
  height: 32px;
  border-radius: 8px;
  padding-inline: 10px;
  margin-right: 10px;
  outline: none;
  border: 1px solid ${COLORS.mainColor};
  -webkit-appearance: none;
  ${FONTS.font16};
  cursor: pointer;

  option {
    ${FONTS.font16};
  }
`;

export const DeleteAndSearchBlock = styled.div`
  display: flex;
  justify-content: space-between;
  width: 684px;
  height: 32px;
`;

export const DeleteAllButton = styled.button`
  width: 128px;
  height: 32px;
  background: ${COLORS.mainColor};
  border: 1px solid ${COLORS.lightSilver};
  color: ${COLORS.white};
  ${FONTS.font16};
  ${FONT_FAMILY.FontRegular};
  border-radius: 8px;

  &:hover {
    background: transparent;
    color: ${COLORS.lightSilver};
  }
`;

export const SearchWrapper = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  width: 280px;
  border: 1px solid ${COLORS.lightSilver};
  border-radius: 8px;
  padding-right: 10px;
`;

export const SearchInput = styled.input`
  width: 270px;
  height: 32px;
  padding-left: 10px;
  padding-right: 2px;
  background: transparent;
  border: none;
`;

export const TableBlock = styled.table`
  margin-top: 20px;
  width: 100%;
  border-collapse: collapse;
`;

export const TableBody = styled.tbody``;

export const TableLine = styled.tr`
  border-bottom: 1px solid ${COLORS.lightSilver};
`;

export const TableElement = styled.td`
  height: 60px;
`;

export const TableSampleBlock = styled.div`
  display: flex;
  gap: 10px;
  width: ${({ title }) => title && '260px'};
`;

export const EditAndDeleteButton = styled.img`
  cursor: pointer;
`;

export const EditModalWrapper = styled.div`
  display: flex;
  flex-direction: column;
  gap: 20px;
  flex-shrink: 2;
  width: 100%;
  overflow-y: auto;
  position: relative;

  &::-webkit-scrollbar {
    width: 5px;
  }

  &::-webkit-scrollbar-track {
    box-shadow: inset 0 0 5px ${COLORS.darkGray};
    background: ${COLORS.lightGray};
    border-radius: 10px;
  }

  &::-webkit-scrollbar-thumb {
    background: ${COLORS.mainColor};
    border-radius: 10px;
  }
`;

export const EditModalBlock = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  width: 100%;
  padding: 6px 176px 18px;
`;

export const CloseIcon = styled.img`
  position: absolute;
  right: ${({ closeSuggestions }) => (closeSuggestions ? '38px' : '22px')};
  top: 22px;
  width: 12px;
  height: 12px;
  cursor: pointer;
`;

export const EditModalContainer = styled.form`
  display: flex;
  flex-direction: column;
  gap: 24px;
  width: 100%;
`;

export const OutlinedInput = styled(TextField)`
  width: 100%;
  height: ${({ isDescription }) => (isDescription ? '96px' : 'auto')};

  [class*='MuiFormLabel-root']:not([class*='MuiInputLabel-shrink']) {
    top: -9px !important;
  }

  .material-ui-description {
    position: absolute;
    top: -22px;
  }

  .MuiInputLabel-outlined {
    top: unset;
  }

  .MuiInputBase-root {
    height: ${({ isDescription }) => (isDescription ? '96px' : '36px')} !important;
  }

  .MuiInputBase-input {
    height: ${({ isDescription }) => (isDescription ? '96px' : '36px')} !important;
    padding: unset;
    padding-left: 10px;
    vertical-align: top;
  }

  .Mui-focused {
    color: ${COLORS.mainColor} !important;
  }

  .Mui-focused .MuiOutlinedInput-notchedOutline {
    border-color: ${COLORS.mainColor} !important;
  }
`;

export const InputsContainer = styled.div`
  display: flex;
  justify-content: space-between;
  flex-wrap: wrap;
  gap: ${({ isSmall }) => (isSmall ? '24px' : 'unset')};
  width: 100%;
  height: ${({ isSmall }) => (isSmall ? 'auto' : '300px')};
  flex-shrink: 0;

  [class*='MuiFormLabel-root']:not([class*='MuiInputLabel-shrink']) {
    top: -9px !important;
  }
`;

export const SmallOutlinedInputParent = styled.div`
  position: relative;
  width: ${({ isFull, isDeleteIcon }) =>
    isFull ? '100%' : isDeleteIcon ? '240px' : '270px'};
  height: 36px;
`;

export const SmallOutlinedInput = styled(TextField)`
  width: ${({ isFull, isDeleteIcon }) =>
    isFull ? '100%' : isDeleteIcon ? '240px' : '270px'};
  height: 36px;

  .MuiInputBase-root {
    height: 36px !important;
  }

  .MuiSelect-icon {
    display: none;
  }

  .Mui-focused {
    color: ${COLORS.mainColor} !important;
  }
  .Mui-focused .MuiOutlinedInput-notchedOutline {
    border-color: ${COLORS.mainColor} !important;
  }

  .MuiInputBase-input {
    height: 36px !important;
    padding: unset;
    padding-left: 10px;
  }

  .MuiSelect-select {
    padding-top: 11px;
  }
`;

export const ImageUploaderWrapper = styled.div`
  display: flex;
  justify-content: space-between;
  width: 100%;
  height: 120px;
  flex-shrink: 0;
`;

export const ImageUpload = styled.div`
  display: flex;
  justify-content: center;
  flex-direction: column;
  align-items: center;
  position: relative;
  width: 270px;
  height: 120px;
  background: ${({ backgroundImage }) =>
    backgroundImage ? `url(${backgroundImage})` : 'unset'};
  box-shadow: ${({ backgroundImage }) =>
    backgroundImage ? 'inset 0 0 80px 1px #282a2d' : 'unset'};
  background-size: cover;
  border: 1px solid ${COLORS.lightSilver};
  border-radius: 8px;
`;

export const InfoAboutBlock = styled.span`
  color: ${({ backgroundImage }) =>
    backgroundImage ? COLORS.white : COLORS.lightSilver};
  ${FONTS.font16};
  ${FONT_FAMILY.FontRegular};
`;

export const PlusIcon = styled.img`
  width: 16px;
  height: 16px;
`;

export const FileUploadInput = styled.input`
  position: absolute;
  width: 270px;
  height: 120px;
  z-index: 12;
  -webkit-appearance: none;
  opacity: 0;
  cursor: pointer;
`;

export const AddAnother = styled.span`
  cursor: pointer;
  color: ${COLORS.lightSilver};
  ${FONTS.font16};
  ${FONT_FAMILY.FontRegular};
`;

export const SuggestionContainer = styled.div`
  display: flex;
  justify-content: center;
  flex-wrap: wrap;
  width: 100%;
  height: 46px;
`;

export const AddSuggestion = styled.button`
  width: 172px;
  height: 46px;
  background: ${COLORS.mainColor};
  color: ${COLORS.white};
  ${FONTS.font16};
  border-radius: 8px;
`;

export const PackageSuggestionsWrapper = styled.div`
  display: flex;
  flex-direction: column;
  gap: 20px;
  width: 100%;
  height: auto;
  position: relative;
  flex-shrink: 0;
`;

export const PackageSuggestionTopBlock = styled.div`
  display: flex;
  flex-direction: column;
  gap: 20px;
  width: 100%;
  padding-left: 43px;
`;

export const SelectFromTemplates = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  position: relative;
  cursor: pointer;
  padding-inline: 10px;
  width: 300px;
  height: 40px;
  border-radius: 8px;
  border: 1px solid #686868;
  margin-right: 43px;
`;

export const SuggestionsBlock = styled.div`
  display: flex;
  gap: 12px;
  justify-content: start;
  width: 100%;
  height: auto;
`;

export const SuggestionItem = styled.div`
  display: flex;
  flex-direction: column;
  gap: 4px;
  border-radius: 12px;
  width: 216px;
  height: 224px;
  border: 1px solid ${COLORS.lightSilver};
  padding-bottom: 10px;
`;

export const SuggestionMainItem = styled.div`
  border-top-left-radius: 12px;
  border-top-right-radius: 12px;
  width: 100%;
  height: 100px;
  background: url(${Images.bali});
  background-size: cover;
  background-repeat: no-repeat;
  background-position: center;
`;

export const SuggestionTitleAndDeleteButton = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  width: 100%;
  height: 30px;
  padding-left: 10px;
  padding-right: 10px;
`;

export const SuggestionMainTitle = styled.span`
  color: ${COLORS.mainColor};
  ${FONTS.font16};
  ${FONT_FAMILY.FontMedium};
`;

export const SuggestionDeleteWrapper = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  width: 32px;
  height: 25px;
  background: ${COLORS.ultralightGray};
  border-radius: 2px;
  cursor: pointer;
`;

export const SuggestionDeleteButton = styled.img``;

export const SuggestionMainDescription = styled.span`
  color: ${COLORS.lightSilver};
  ${FONTS.font16};
  ${FONT_FAMILY.FontRegular};
  display: -webkit-box;
  -webkit-line-clamp: 4;
  -webkit-box-orient: vertical;
  overflow: hidden;
  text-overflow: ellipsis;
  padding-left: 10px;
  padding-right: 10px;
`;

export const SaveButtonWrapper = styled.div`
  display: flex;
  justify-content: end;
  align-items: center;
  gap: 10px;
  width: 100%;
  height: 46px;
`;

export const KeepChanges = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  gap: 12px;
  width: 156px;
  height: 46px;
`;

export const KeepChangesText = styled.span`
  color: ${COLORS.lightSilver};
  ${FONTS.font16};
  ${FONT_FAMILY.FontRegular};
`;

export const KeepChangesCheckboxWrapper = styled.div`
  position: relative;
  width: 18px;
  height: 18px;
`;

export const KeepChangesCheckbox = styled.input`
  width: 18px;
  height: 18px;
  cursor: pointer;
  -webkit-appearance: none;
  border: 1px solid ${COLORS.lightSilver};
  border-radius: 2px;
`;

export const CheckedIcon = styled.img`
  position: absolute;
  width: 10px;
  height: 8px;
  right: 4px;
  top: 5px;
  pointer-events: none;
`;

export const SaveButton = styled.button`
  ${FONTS.font16};
  ${FONT_FAMILY.FontRegular};
  color: ${COLORS.white};
  background: ${COLORS.mainColor};
  width: 172px;
  height: 46px;
  border-radius: 8px;
`;

export const PlaceholdersAndCloseIcon = styled.div`
  width: 100%;
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: space-between;
`;

export const RightPlaceholders = styled.div`
  width: 270px;
  display: flex;
  justify-content: start;
  gap: 14px;
  align-items: center;
`;

export const DeleteIcon = styled.img`
  width: 12px;
  height: 12px;
  cursor: pointer;
`;

export const ViewDataWrapper = styled.div`
  position: relative;
  display: flex;
  flex-direction: column;
  gap: 24px;
  width: 100%;
  height: auto;
  background: ${COLORS.white};
  margin-bottom: 40px;
`;

export const PackageNameAndAddress = styled.span`
  ${FONTS.font24};
  ${FONT_FAMILY.FontBold};
  color: ${COLORS.mainColor};
`;

export const PackageMainInfo = styled.div`
  width: 100%;
  height: auto;
  display: flex;
  flex-direction: column;
  gap: 8px;
`;

export const PackageLine = styled.div`
  display: flex;
  align-items: center;
  position: relative;
  gap: 76px;
  width: 100%;
  min-height: 47px;
  background: ${COLORS.ultralightGray};
  border-radius: 8px;
`;

export const FieldName = styled.span`
  align-self: start;
  ${FONTS.font16};
  ${FONT_FAMILY.FontRegular};
  width: 110px;
  position: relative;
  top: 14px;
  left: 14px;
  height: 22px;
`;

export const FieldValue = styled.span`
  width: 90%;
  padding-top: 2px;
  padding-bottom: 2px;
`;

export const FieldImages = styled.div`
  display: flex;
  gap: 12px;
`;

export const FieldImage = styled.img`
  width: 94px;
  height: 94px;
  border-radius: 8px;
  margin-bottom: 16px;
  margin-top: 12px;
`;

export const PackageCloseIcon = styled.img`
  width: 14px;
  height: 14px;
  position: absolute;
  right: 6px;
  top: 7px;
  cursor: pointer;
`;
